/**
 * Prepends `https://` when a non-empty value has no http(s) scheme.
 * Whitespace-only becomes `''`. Null/undefined pass through.
 */
export function ensureHttpsUrl(value: string): string;
export function ensureHttpsUrl(value: null | undefined): null | undefined;
export function ensureHttpsUrl(
  value: string | null | undefined,
): string | null | undefined {
  if (value == null) return value;
  const trimmed = value.trim();
  if (!trimmed) return '';
  return /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
}
